import { ChildrenItem } from "dependencies/base"
import { Swiper } from "./model"
import { home, bs, appHome } from "./diffrence_options"
// import icon from "../../assets/images/leftMenu/basePortal/icon_carousel.png"
import bigScreenIcon from "assets/images/leftMenu/component/cx_swiper.png"
let icon = "icon-portal-menu_swiper"
export let swiper_children = []
export let bigScreen_swiper_children = []
export let app_swiper_children = []
let cover = [
  require("assets/images/leftMenu/swiper/swiper1.png"),
  require("assets/images/leftMenu/swiper/swiper2.png"),
  require("assets/images/leftMenu/swiper/swiper3.png"),
  require("assets/images/leftMenu/swiper/swiper4.png"),
  require("assets/images/leftMenu/swiper/swiper5.png"),
  require("assets/images/leftMenu/swiper/swiper6.png"),
  require("assets/images/leftMenu/swiper/swiper7.png"),
  require("assets/images/leftMenu/swiper/swiper8.png"),
  require("assets/images/leftMenu/swiper/home-swiper9.png"),
]
for (let i = 0; i < home.length; i++) {
  swiper_children.push(new ChildrenItem("样式" + (i + 1), icon, "swiperComponent", new Swiper(home[i]), cover[i]))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_swiper_children.push(
    new ChildrenItem("样式" + (i + 1), bigScreenIcon, "swiperComponent", new Swiper(bs[i]))
  )
}
for (let i = 0; i < appHome.length; i++) {
  app_swiper_children.push(new ChildrenItem("样式" + (i + 1), icon, "swiperComponent", new Swiper(appHome[i]), cover[i]))
}
